export default {
  "dropdown": "_dropdown_tn7laa",
  "trigger": "_trigger_tn7laa",
  "open": "_open_tn7laa",
  "timeline": "_timeline_tn7laa",
  "list": "_list_tn7laa"
};